module.exports = __webpack_public_path__ + "img/loginlogo.259a4b30.svg";